import { DocType } from "./DocType";

export interface DocTip {
  docTypes: DocType[];
  tip: string;
}

export class DocTips {
  private static DOC_TIPS: DocTip[] = [
    {
      docTypes: [
        DocType.LICENSE_BACK,
        DocType.LICENSE_FRONT,
        DocType.LICENSE_FRONT_AND_BACK,
      ],
      tip: "Place your ID on plain dark background.",
    },
    {
      docTypes: [
        DocType.LICENSE_BACK,
        DocType.LICENSE_FRONT,
        DocType.LICENSE_FRONT_AND_BACK,
      ],
      tip: "Get all 4 corners in the frame.",
    },
    {
      docTypes: [
        DocType.LICENSE_BACK,
        DocType.LICENSE_FRONT,
        DocType.LICENSE_FRONT_AND_BACK,
      ],
      tip: "We'll automatically capture the image when everything looks good!",
    },
  ];

  public static getDocTips(docType: DocType): DocTip[] {
    return DocTips.DOC_TIPS.filter( (v) => v.docTypes.indexOf(docType) >= 0 );
  }
}



// WEBPACK FOOTER //
// ./src/constants/DocTips.ts